import { FC } from "react";
import styled from "styled-components";

interface IIcon {
  name: string;
  color?: string;
  size: 16 | 24 | 32 | 64 | number;
}

interface IStyledIcon {
  color: string;
  size: 16 | 24 | 32 | 64 | number;
}

const StyledIcon = styled.svg<IStyledIcon>`
  display: inline-block;
  vertical-align: middle;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  fill: ${(props) => `var(--color-${props.color})`};
  transition: fill 0.4s;
`;

export const Icon:FC<IIcon> = ({
  name,
  color = "black",
  size = 24
}): JSX.Element => {

  return (
    <StyledIcon color={color} size={size}>
      <use xlinkHref={`#${name}`} />
    </StyledIcon>
  )
}